import React from 'react';

import styles from './input-title.module.scss';

type Props = {
	title: string;
};

export const InputTitle = ({ title }: Props) => <span className={styles.inputTitle}>{title}</span>;
